import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  ECreativeStatus,
  EReportingTimeWindow,
  EReportColumnHeader,
  IReportingCreativesTableResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAAdGroupsCreativesReportTableFilters,
  TDACreativesReportTableFilters,
  TDOOHAdGroupsCreativesReportTableFilters,
  TDOOHCreativesReportTableFilters,
  TPPAdvertiserId,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetAdvertiserReportinCreativesTableV3({
  advertiserId,
  retailerId,
  inventoryType,
  campaignId,
  adGroupId,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (
  | TDACreativesReportTableFilters
  | TDAAdGroupsCreativesReportTableFilters
  | TDOOHCreativesReportTableFilters
  | TDOOHAdGroupsCreativesReportTableFilters
) &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IReportingCreativesTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingCreativesTable_${advertiserId}_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, inventoryType }],
    () => {
      return coreAPIV3
        .advertiserReporting()
        .getAdvertiserCreativesReportTableV3(
          advertiserId,
          generateCorrelationId(),
          retailerId,
          campaignId,
          adGroupId,
          sortBy as EReportColumnHeader,
          sortOrder,
          timeWindow as unknown as EReportingTimeWindow,
          startDate,
          endDate,
          tzZone || getTimezone(),
          pageLimit,
          pageOffset,
          filterBy,
          filterOperation,
          filterValue,
          name,
          // @ts-expect-error: fix in PORT-2535
          status as ECreativeStatus | undefined
        )
    },
    { suspense, enabled }
  )
}
